import { IngredientBaseUnit, IngredientStatus } from "../../sdk/types/api";

export const ingredientBaseUnitNames: Record<IngredientBaseUnit, string> = {
    [IngredientBaseUnit.GRAM]: "Grams (g)",
    [IngredientBaseUnit.MILLILITRE]: "Millilitres (ml)",
    [IngredientBaseUnit.PIECE]: "Pieces (pcs)",
};

export const ingredientStatusNames: Record<IngredientStatus, string> = {
    [IngredientStatus.ACTIVE]: "Active",
    [IngredientStatus.INACTIVE]: "Inactive",
};

export const ingredientQueryKeys = {
    list: "ingredients",
    detail: "ingredient",
    categories: "ingredientCategories",
    unmatched: "unmatchedIngredients",
};
